import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DiagnosticOrderActionsService } from '@ispm/dashboard/test/services/diagnostic-order-actions.service';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { TestClickedEvent } from '../vertical-test-actions-list/vertical-test-actions-list.component';
import { IDiagnosticOrder } from '@ispm/dashboard/test/interfaces/diagnostic-order.interface';
import { DashboardService } from '../../../../../worklist/services/dashboard.service';
import { get, has } from 'lodash';
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { RevisionStatus } from '@ispm/workflow/constants/revisionStatus.enum';
import { TestBarEnableConfirmButtonAction } from '@ispm/test/store/test-bar.actions';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {Router} from '@angular/router';
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";

@Component({
  selector: 'ispm-vertical-test-actions-container',
  templateUrl: './vertical-test-actions-container.component.html',
  styleUrls: ['./vertical-test-actions-container.component.scss'],
})
export class VerticalTestActionsContainerComponent implements OnInit {
  isVisible = false;
  actionTests$: Observable<IDiagnosticOrder[]>;
  currentRevisionId: string;
  currentTemplateName: string = '';
  constructor(
    private diagnosticOrderAC: DiagnosticOrderActionsService,
    private _dashboardService: DashboardService,
    private store: Store<IgenomicsState>,
    private routerManagerService: RouterManagerService,
    private router: Router
  ) { }

  ngOnInit() {
    this._dashboardService.getCurrentWorkflowTemplateName().subscribe(name => this.currentTemplateName = name);
    this.initActionTests();
    this.currentRevisionId = this.routerManagerService.parameters.revisionId;
  }

  private initActionTests(): void {
    if (this.hasPatientContext) {

      // original code
      this.actionTests$ = this.diagnosticOrderAC.getState()
        .pipe(
            distinctUntilChanged(),
            filter((state) => !!state.allOrders),
            map((state) => state.allOrders.toArray()),
            map((ordersToFilter) => {
                if (this.currentTemplateName.length > 0) {
                  const selectedOrders = ordersToFilter.filter(item => {
                    const revisions = get(item, 'revisions', []);
                    return revisions.length > 0 && has(revisions[0], 'templateId') ? get(revisions[0], 'templateId', '') === this.currentTemplateName : item;
                  });
                  return selectedOrders;
                }
                return ordersToFilter;
              } )
        );
    }
  }

  selectTest(event$: TestClickedEvent): void {
    if (this.currentRevisionId !== event$.revisionId) {
      this.currentRevisionId = event$.revisionId;

      const test = {
        testId: event$.testId,
        revisionId: event$.revisionId,
        patientId: this.routerManagerService.parameters.patientId,
      };
      this.router.navigate(['Pathologist','PatientProfile',test.patientId,test.testId,test.revisionId]);
      if (event$.status === RevisionStatus.PathwaySelection) {
        this.store.dispatch(new TestBarEnableConfirmButtonAction(false));
      }
    }
  }

  private get hasPatientContext(): boolean {
    return !!this.routerManagerService.parameters.patientId;
  }

  popupTestCreation($event) {
    this._dashboardService.runConfiguration(
      $event.testConfig,
      null,
      $event.patientId
    );
  }
}
